export default "<app-appointment [id]=\"id\">\r\n</app-appointment>\r\n"